import { Button } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { t } from "i18next";
import { useStores } from "../../../shared/stores/RootStore";
import { CustomDialog } from "../../../shared/views/CustomDialog";

const NodeRefreshAlertBase: React.FC = () => {
  const { craNodeStore } = useStores();

  if (!craNodeStore.showNodeRefreshAlert) return null;

  const refreshNodes = async () => {
    craNodeStore.closeNodeRefreshAlert();

    for (const craWayId of craNodeStore.nodesByWayId.keys()) {
      await craNodeStore.fetchNodes(craWayId);
    }
  };

  return (
    <CustomDialog
      size="md"
      onClose={craNodeStore.closeNodeRefreshAlert}
      header={t("shared:nodeRefreshAlert.title")}
      footer={
        <Button colorPalette="primary" onClick={refreshNodes}>
          {t("shared:nodeRefreshAlert.action")}
        </Button>
      }
    >
      {t("shared:nodeRefreshAlert.description")}
    </CustomDialog>
  );
};

export const NodeRefreshAlert = observer(NodeRefreshAlertBase);
